import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import join from 'lodash/join';

const detailsTab = commissionTier => {
  const categoryType = commissionTier.category;
  const triggerPointStr =
    commissionTier?.triggerPoint === 'CREATED' ? 'Create Order/Opp' : 'Order/Opp Completed';
  let isTranslation = false;
  const baseObj = [
    {
      name: 'cms:cms.properties.edit.tab_label.trigger',
      children: [['cms:cms.properties.edit.tab_label.trigger_name', triggerPointStr]],
    },
  ];
  const handleEmptyFields = field => {
    const dataField = commissionTier[field];
    if (field === 'application_to_rooms') {
      if (isEmpty(dataField)) {
        isTranslation = true;
        return 'cms:cms.property.commission_form_modal.commission_details.all_rooms';
      }

      const result = join(
        map(dataField, item => {
          if (isEmpty(item.name)) {
            return '';
          }
          return item.name;
        }),
        ',',
      );

      return result;
    }

    return dataField || '-';
  };

  // Re-booker commission
  const rebookers = [
    {
      name: 'cms:cms.properties.edit.tab_label.details',
      children: [
        [
          'cms:cms.property.commission_form_modal.commission_category.lable',
          handleEmptyFields('category'),
        ],
        [
          'cms:cms.property.commission_form_modal.commission_category.bonus',
          handleEmptyFields('bonus'),
        ],
        ['cms:cms.property.commission_form_modal.commission_name.lable', handleEmptyFields('name')],
        [
          'cms:cms.property.commission_form_modal.commission_type.lable',
          handleEmptyFields('calculation_type'),
        ],
        [
          'cms:cms.property.commission_form_modal.commission_value.lable',
          handleEmptyFields('calculation_value'),
        ],
        [
          'cms:cms.property.commission_form_modal.effective_from.lable',
          handleEmptyFields('effective_from'),
        ],
        [
          'cms:cms.property.commission_form_modal.effective_to.lable',
          handleEmptyFields('effective_to'),
        ],
      ],
    },
    {
      name: 'cms:cms.property.commission_form_modal.extra_requirement',
      children: [
        [
          'cms:cms.property.commission_form_modal.commission_details.check_from',
          handleEmptyFields('check_in_date_from'),
        ],
        [
          'cms:cms.property.commission_form_modal.commission_details.check_to',
          handleEmptyFields('check_in_date_to'),
        ],
      ],
    },
    {
      name: 'cms:cms.property.commission_form_modal.commission_details.application_rooms',
      children: [[handleEmptyFields('application_to_rooms'), 'singleLine', isTranslation]],
    },
  ];

  // Flat commission
  const flat = [
    {
      name: 'cms:cms.properties.edit.tab_label.details',
      children: [
        [
          'cms:cms.property.commission_form_modal.commission_category.lable',
          handleEmptyFields('category'),
        ],
        [
          'cms:cms.property.commission_form_modal.commission_category.bonus',
          handleEmptyFields('bonus'),
        ],
        ['cms:cms.property.commission_form_modal.commission_name.lable', handleEmptyFields('name')],
        [
          'cms:cms.property.commission_form_modal.commission_type.lable',
          handleEmptyFields('calculation_type'),
        ],
        [
          'cms:cms.property.commission_form_modal.commission_value.lable',
          handleEmptyFields('calculation_value'),
        ],
        [
          'cms:cms.property.commission_form_modal.converted_commission.lable',
          handleEmptyFields('convert_commission'),
        ],
        [
          'cms:cms.property.commission_form_modal.effective_from.lable',
          handleEmptyFields('effective_from'),
        ],
        [
          'cms:cms.property.commission_form_modal.effective_to.lable',
          handleEmptyFields('effective_to'),
        ],
      ],
    },
    {
      name: 'cms:cms.property.commission_form_modal.extra_requirement',
      children: [
        [
          'cms:cms.property.commission_form_modal.commission_details.tenancy',
          handleEmptyFields('tenancy_length'),
        ],
        [
          'cms:cms.property.commission_form_modal.tenancy_unit.lable',
          handleEmptyFields('tenancy_unit'),
        ],
        [
          'cms:cms.property.commission_form_modal.commission_details.booking_count_from',
          handleEmptyFields('booking_count_from'),
        ],
        [
          'cms:cms.property.commission_form_modal.commission_details.booking_count_to',
          handleEmptyFields('booking_count_to'),
        ],
        [
          'cms:cms.property.commission_form_modal.commission_details.check_from',
          handleEmptyFields('check_in_date_from'),
        ],
        [
          'cms:cms.property.commission_form_modal.commission_details.check_to',
          handleEmptyFields('check_in_date_to'),
        ],
      ],
    },
    {
      name: 'cms:cms.property.commission_form_modal.commission_cap',
      children: [
        [
          'cms:cms.property.commission_form_modal.commission_cap_type.lable',
          handleEmptyFields('commission_cap_type'),
        ],
        [
          'cms:cms.property.commission_form_modal.commission_cap',
          handleEmptyFields('commission_cap'),
        ],
      ],
    },
    {
      name: 'cms:cms.property.commission_form_modal.commission_details.application_rooms',
      children: [[handleEmptyFields('application_to_rooms'), 'singleLine', isTranslation]],
    },
    {
      name: 'cms:cms.property.commission_form_modal.note',
      children: [
        [
          'cms:cms.property.commission_form_modal.commission_not_entirely_covered.lable',
          handleEmptyFields('commission_not_entirely_covered'),
        ],
        [
          'cms:cms.property.commission_form_modal.commission_structure_description.lable',
          handleEmptyFields('commission_structure_description'),
        ],
      ],
    },
  ];

  // Number of bookings commission
  const numBookings = [
    {
      name: 'cms:cms.properties.edit.tab_label.details',
      children: [
        [
          'cms:cms.property.commission_form_modal.commission_category.lable',
          handleEmptyFields('category'),
        ],
        [
          'cms:cms.property.commission_form_modal.commission_category.bonus',
          handleEmptyFields('bonus'),
        ],
        ['cms:cms.property.commission_form_modal.commission_name.lable', handleEmptyFields('name')],
        [
          'cms:cms.property.commission_form_modal.commission_type.lable',
          handleEmptyFields('calculation_type'),
        ],
        [
          'cms:cms.property.commission_form_modal.commission_value.lable',
          handleEmptyFields('calculation_value'),
        ],
        [
          'cms:cms.property.commission_form_modal.converted_commission.lable',
          handleEmptyFields('convert_commission'),
        ],
        [
          'cms:cms.property.commission_form_modal.effective_from.lable',
          handleEmptyFields('effective_from'),
        ],
        [
          'cms:cms.property.commission_form_modal.effective_to.lable',
          handleEmptyFields('effective_to'),
        ],
      ],
    },
    {
      name: 'cms:cms.property.commission_form_modal.extra_requirement',
      children: [
        [
          'cms:cms.property.commission_form_modal.commission_details.tenancy',
          handleEmptyFields('tenancy_length'),
        ],
        [
          'cms:cms.property.commission_form_modal.tenancy_unit.lable',
          handleEmptyFields('tenancy_unit'),
        ],
        [
          'cms:cms.property.commission_form_modal.commission_details.booking_count_from',
          handleEmptyFields('booking_count_from'),
        ],
        [
          'cms:cms.property.commission_form_modal.commission_details.booking_count_to',
          handleEmptyFields('booking_count_to'),
        ],
        [
          'cms:cms.property.commission_form_modal.commission_details.check_from',
          handleEmptyFields('check_in_date_from'),
        ],
        [
          'cms:cms.property.commission_form_modal.commission_details.check_to',
          handleEmptyFields('check_in_date_to'),
        ],
      ],
    },
    {
      name: 'cms:cms.property.commission_form_modal.commission_cap',
      children: [
        [
          'cms:cms.property.commission_form_modal.commission_cap_type.lable',
          handleEmptyFields('commission_cap_type'),
        ],
        [
          'cms:cms.property.commission_form_modal.commission_cap',
          handleEmptyFields('commission_cap'),
        ],
      ],
    },
    {
      name: 'cms:cms.property.commission_form_modal.commission_details.application_rooms',
      children: [[handleEmptyFields('application_to_rooms'), 'singleLine', isTranslation]],
    },
    {
      name: 'cms:cms.property.commission_form_modal.note',
      children: [
        [
          'cms:cms.property.commission_form_modal.commission_not_entirely_covered.lable',
          handleEmptyFields('commission_not_entirely_covered'),
        ],
        [
          'cms:cms.property.commission_form_modal.retrospective_commission.lable',
          handleEmptyFields('retrospective_commission'),
        ],
        [
          'cms:cms.property.commission_form_modal.commission_structure_description.lable',
          handleEmptyFields('commission_structure_description'),
        ],
      ],
    },
  ];

  // Tenancy length commission
  const tenancy = [
    {
      name: 'cms:cms.properties.edit.tab_label.details',
      children: [
        [
          'cms:cms.property.commission_form_modal.commission_category.lable',
          handleEmptyFields('category'),
        ],
        [
          'cms:cms.property.commission_form_modal.commission_category.bonus',
          handleEmptyFields('bonus'),
        ],
        ['cms:cms.property.commission_form_modal.commission_name.lable', handleEmptyFields('name')],
        [
          'cms:cms.property.commission_form_modal.commission_type.lable',
          handleEmptyFields('calculation_type'),
        ],
        [
          'cms:cms.property.commission_form_modal.commission_value.lable',
          handleEmptyFields('calculation_value'),
        ],
        [
          'cms:cms.property.commission_form_modal.converted_commission.lable',
          handleEmptyFields('convert_commission'),
        ],
        [
          'cms:cms.property.commission_form_modal.effective_from.lable',
          handleEmptyFields('effective_from'),
        ],
        [
          'cms:cms.property.commission_form_modal.effective_to.lable',
          handleEmptyFields('effective_to'),
        ],
      ],
    },
    {
      name: 'cms:cms.property.commission_form_modal.extra_requirement',
      children: [
        [
          'cms:cms.property.commission_form_modal.commission_details.tenancy',
          handleEmptyFields('tenancy_length'),
        ],
        [
          'cms:cms.property.commission_form_modal.tenancy_unit.lable',
          handleEmptyFields('tenancy_unit'),
        ],
        [
          'cms:cms.property.commission_form_modal.commission_details.check_from',
          handleEmptyFields('check_in_date_from'),
        ],
        [
          'cms:cms.property.commission_form_modal.commission_details.check_to',
          handleEmptyFields('check_in_date_to'),
        ],
      ],
    },
    {
      name: 'cms:cms.property.commission_form_modal.commission_cap',
      children: [
        [
          'cms:cms.property.commission_form_modal.commission_cap_type.lable',
          handleEmptyFields('commission_cap_type'),
        ],
        [
          'cms:cms.property.commission_form_modal.commission_cap',
          handleEmptyFields('commission_cap'),
        ],
      ],
    },
    {
      name: 'cms:cms.property.commission_form_modal.commission_details.application_rooms',
      children: [[handleEmptyFields('application_to_rooms'), 'singleLine', isTranslation]],
    },
    {
      name: 'cms:cms.property.commission_form_modal.note',
      children: [
        [
          'cms:cms.property.commission_form_modal.commission_not_entirely_covered.lable',
          handleEmptyFields('commission_not_entirely_covered'),
        ],
        [
          'cms:cms.property.commission_form_modal.retrospective_commission.lable',
          handleEmptyFields('retrospective_commission'),
        ],
        [
          'cms:cms.property.commission_form_modal.commission_structure_description.lable',
          handleEmptyFields('commission_structure_description'),
        ],
      ],
    },
  ];

  if (categoryType === 'Re-booker commission') {
    return baseObj.concat(rebookers);
  }

  if (categoryType === 'Flat commission') {
    return baseObj.concat(flat);
  }

  if (categoryType === 'Number of bookings commission') {
    return baseObj.concat(numBookings);
  }

  if (categoryType === 'Tenancy length commission') {
    return baseObj.concat(tenancy);
  }

  return [];
};

export default detailsTab;
